import { useEffect, useRef } from 'react';
import { init } from '@waline/client';
import '@waline/client/style';
import caishenye from '../assets/pics/caishenye.png';

export default function ChatPage() {
  const walineRef = useRef<HTMLDivElement>(null);
  const walineInstanceRef = useRef<ReturnType<typeof init> | null>(null);

  useEffect(() => {
    if (walineRef.current && !walineInstanceRef.current) {
      walineInstanceRef.current = init({
        el: walineRef.current,
        serverURL: 'https://waline.mmbang.site/',
        lang: 'zh-CN',
        dark: 'html.dark',
        meta: ['nick', 'mail'],
        wordLimit: 500,
        pageSize: 10,
      });
    }

    return () => {
      if (walineInstanceRef.current) {
        walineInstanceRef.current.destroy();
        walineInstanceRef.current = null;
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0B0F19] via-[#0F172A] to-[#1E293B] pt-20 pb-12">
      {/* 背景装饰 */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-amber-500/5 blur-[120px] rounded-full" />
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-emerald-500/5 blur-[100px] rounded-full" />
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 页面标题 */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center mb-4 mt-4">
            <img
              src={caishenye}
              alt="caishenye"
              className="w-50 relative left-4"
            />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2 color-gold">
            财神爷镇楼
          </h1>
          <p className="text-gray-400">
            大家在这里可以畅所欲言，分享你的面试经验、交流技术问题或提出建议
          </p>
        </div>

        {/* Waline 评论区 */}
        <div className="bg-[#1E293B]/50 backdrop-blur-sm rounded-2xl border border-white/10 p-6 sm:p-8">
          <div ref={walineRef} className="waline-wrapper" />
        </div>
      </div>

      {/* Waline 样式覆盖 */}
      <style>{`
        .waline-wrapper {
          --waline-font-size: 14px;
          --waline-white: #1E293B;
          --waline-light-grey: #2d3447;
          --waline-dark-grey: #8b92a8;
          --waline-text-color: #e2e8f0;
          --waline-text-light-color: #94a3b8;
          --waline-border-color: rgba(255, 255, 255, 0.1);
          --waline-disable-bg-color: rgba(255, 255, 255, 0.05);
          --waline-disable-color: #64748b;
          --waline-code-bg-color: rgba(0, 0, 0, 0.3);
          --waline-bq-color: rgba(255, 255, 255, 0.05);
          --waline-avatar-radius: 50%;
          --waline-badge-color: #f59e0b;
          --waline-badge-font-size: 10px;
          --waline-info-bg-color: rgba(245, 158, 11, 0.1);
          --waline-info-color: #fbbf24;
          --waline-theme-color: #f59e0b;
          --waline-active-color: #d97706;
        }

        .waline-wrapper .wl-panel {
          background: rgba(30, 41, 59, 0.8);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 12px;
          margin-bottom: 1rem;
        }

        .waline-wrapper .wl-input,
        .waline-wrapper .wl-editor {
          background: rgba(0, 0, 0, 0.3) !important;
          border: 1px solid rgba(255, 255, 255, 0.1);
          color: #e2e8f0 !important;
          border-radius: 8px;
          font-size: 15px;
        }

        /* 昵称和邮箱输入框文字大小 */
        .waline-wrapper .wl-input[name="nick"],
        .waline-wrapper .wl-input[name="mail"] {
          font-size: 15px;
        }

        .waline-wrapper .wl-input:focus,
        .waline-wrapper .wl-editor:focus {
          border-color: #f59e0b;
          outline: none;
        }

        /* 修复自动填充时的背景色 */
        .waline-wrapper .wl-input:-webkit-autofill,
        .waline-wrapper .wl-input:-webkit-autofill:hover,
        .waline-wrapper .wl-input:-webkit-autofill:focus,
        .waline-wrapper .wl-input:-webkit-autofill:active {
          -webkit-box-shadow: 0 0 0 30px #1E293B inset !important;
          -webkit-text-fill-color: #e2e8f0 !important;
          transition: background-color 5000s ease-in-out 0s;
        }

        .waline-wrapper .wl-btn {
          background: linear-gradient(135deg, #f59e0b, #d97706);
          border: none;
          border-radius: 8px;
          color: white;
          font-weight: 500;
          transition: all 0.3s ease;
          box-shadow: 0 4px 12px rgba(245, 158, 11, 0.25);
        }

        .waline-wrapper .wl-btn:hover {
          background: linear-gradient(135deg, #fbbf24, #f59e0b);
          color: white;
          transform: translateY(-1px);
          box-shadow: 0 6px 20px rgba(245, 158, 11, 0.4);
        }

        .waline-wrapper .wl-card {
          background: rgba(30, 41, 59, 0.5);
          border: 1px solid rgba(255, 255, 255, 0.05);
          border-radius: 12px;
          margin-bottom: 1rem;
          padding: 1rem;
        }

        .waline-wrapper .wl-nick {
          color: #fbbf24;
          font-weight: 600;
        }

        .waline-wrapper .wl-time {
          color: #64748b;
        }

        .waline-wrapper .wl-content {
          color: #f1f5f9 !important;
          font-size: 15px;
          line-height: 1.7;
          font-weight: 400;
        }

        .waline-wrapper .wl-content p {
          margin: 0.75rem 0;
          color: #f1f5f9 !important;
        }

        .waline-wrapper .wl-content * {
          color: #f1f5f9 !important;
        }

        .waline-wrapper .wl-content a {
          color: #fbbf24 !important;
          text-decoration: underline;
        }

        .waline-wrapper .wl-content code {
          background: rgba(0, 0, 0, 0.4);
          padding: 2px 6px;
          border-radius: 4px;
          font-family: monospace;
          font-size: 13px;
        }

        .waline-wrapper .wl-content pre {
          background: rgba(0, 0, 0, 0.4);
          padding: 12px;
          border-radius: 8px;
          overflow-x: auto;
        }

        .waline-wrapper .wl-content blockquote {
          border-left: 3px solid #f59e0b;
          padding-left: 12px;
          margin: 0.75rem 0;
          color: #94a3b8 !important;
        }

        .waline-wrapper .wl-content blockquote * {
          color: #94a3b8 !important;
        }

        .waline-wrapper .wl-meta {
          border-bottom: 1px solid rgba(255, 255, 255, 0.05);
          padding-bottom: 0.75rem;
          margin-bottom: 0.75rem;
        }

        .waline-wrapper .wl-sort {
          color: #94a3b8;
        }

        .waline-wrapper .wl-sort li.active {
          color: #f59e0b;
        }

        .waline-wrapper .wl-empty {
          color: #64748b;
          padding: 2rem 0;
        }

        .waline-wrapper .wl-avatar {
          border: 2px solid rgba(245, 158, 11, 0.3);
        }

        .waline-wrapper .wl-action svg {
          fill: #64748b;
        }

        .waline-wrapper .wl-action:hover svg {
          fill: #f59e0b;
        }

        .waline-wrapper .wl-like-count,
        .waline-wrapper .wl-comment-count {
          color: #94a3b8;
        }

        /* 评论数徽章 */
        .waline-wrapper .wl-count {
          color: #fbbf24;
          font-size: 12px;
          font-weight: 500;
        }

        /* 加载动画图标 */
        .waline-wrapper .wl-loading {
          color: #fbbf24;
        }

        .waline-wrapper .wl-loading svg {
          fill: #fbbf24;
        }

        /* 加载中的 spinner */
        .waline-wrapper .wl-spinner {
          border-color: rgba(251, 191, 36, 0.3);
          border-top-color: #fbbf24;
        }

        /* 加载更多按钮 */
        .waline-wrapper .wl-load-more {
          color: #94a3b8;
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 8px;
          padding: 8px 16px;
          transition: all 0.3s ease;
        }

        .waline-wrapper .wl-load-more:hover {
          color: #e2e8f0;
          background: rgba(255, 255, 255, 0.1);
        }

        /* 提交按钮加载状态 */
        .waline-wrapper .wl-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }
      `}</style>
    </div>
  );
}
